document.addEventListener("DOMContentLoaded", function() {
    const button = document.querySelector(".button--whatsapp");

    function generateWhatsAppMessage(cart) {
        let message = "Olá, vim do site e gostaria de finalizar o pedido com os seguintes itens:\n\n";
        let total = 0;

        cart.items.forEach(item => {
            const name = `*${item.product_title}*`;
            const variant = item.variant_title ? `Cor/Tamanho: ${item.variant_title}` : "";
            const quantity = `Quantidade: ${item.quantity}`;
            const price = (item.final_line_price / 100).toFixed(2);
            const priceLine = `Preço unitário: R$${price}`;
            total += parseFloat(price) * item.quantity;

            message += `${name}\n${variant}\n${quantity}\n${priceLine}\n\n-----\n\n`;
        });

        message += `*Total do pedido: R$${total.toFixed(2)}*`;
        return encodeURIComponent(message);
    }

    fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            const message = generateWhatsAppMessage(cart);
            const phoneNumber = "5581985280387"; // Número de telefone de teste no formato internacional
            const whatsappLink = `https://wa.me/${phoneNumber}?text=${message}`;
            button.href = whatsappLink;
        })
        .catch(error => console.error('Erro ao acessar o carrinho:', error));
});
